import EndpointDetailElement from "./EndpointDetailElement";
import EndpointDetailBootUpTime from "./EndpointDetailBootUpTime";
import { toFormatedDate, getUtcOffset } from "system/libraries/utilities";
import IMachineDetails from "system/types/interfaces/IMachineDetails";

interface IProps {
  machineDetails: IMachineDetails
};

const EndpointDetailTable = ({ machineDetails } : IProps ) => {
  if (!machineDetails || !machineDetails.machineFacts) {
    return <></>;
  }

  const lastReportedTime = machineDetails?.subjectStatuses?.length
    ? machineDetails.subjectStatuses[0].lastReportedJsTime
    : "";
  const lastReportedDate = lastReportedTime ? new Date(lastReportedTime) : null;

  return (
    <div className="row scroll">
      <div className="col-md-6">
        <table>
          <tbody>
            <EndpointDetailElement facts={machineDetails.machineFacts} code="COMPUTERNAME" />
            <EndpointDetailElement facts={machineDetails.machineFacts} code="CONFIG" />
            <EndpointDetailElement facts={machineDetails.machineFacts} code="ADSITE" />
            <EndpointDetailElement facts={machineDetails.machineFacts} code="MFR" />
            <EndpointDetailElement facts={machineDetails.machineFacts} code="MODEL" />
            <EndpointDetailElement facts={machineDetails.machineFacts} code="BOARDSER" />
            <EndpointDetailElement facts={machineDetails.machineFacts} code="BIOSVER" />
          </tbody>
        </table>
      </div>
      <div className="col-md-6">
        <table>
          <tbody>
            <tr>
              <td><span className="endpoint-fact-code">Last recorded</span></td>
              <td><span className="endpoint-fact-value ms-2">: {toFormatedDate(lastReportedTime)}{lastReportedDate && ` (Device local time UTC${getUtcOffset(lastReportedDate)})`}</span></td>
            </tr>
            <EndpointDetailElement facts={machineDetails.machineFacts} code="OSNAME" />
            <EndpointDetailElement facts={machineDetails.machineFacts} code="OSVER" />
            <EndpointDetailElement facts={machineDetails.machineFacts} code="OSARCH" />
            <EndpointDetailBootUpTime facts={machineDetails.machineFacts} code="LASTBOOTTIME" />
            <EndpointDetailElement facts={machineDetails.machineFacts} code="REPO" />
            <tr>
              <td><span className="endpoint-fact-code">Endpoint ID</span></td>
              <td><span className="endpoint-fact-value ms-2">: {machineDetails.comboId}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EndpointDetailTable;